import { render, staticRenderFns } from "./RagioneriaTariffeView.vue?vue&type=template&id=f314d442&"
import script from "./RagioneriaTariffeView.vue?vue&type=script&lang=ts&"
export * from "./RagioneriaTariffeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports